import { gql } from "@apollo/client";

export const VERIFICAR_SOLICITUDES_ENVIADAS = gql`
query VerificarSolicitudesEnviadas {
    verificarSolicitudesEnviadas {
        success,
        error,
        valorEsperado
    }
}`;